<mat-select
  *ngIf="params.context.componentParent.showRowInEditMode(params.node)"
  [(ngModel)]="selectedPlant"
  (ngModelChange)="setPlantColorId()">
  <mat-option *ngFor="let plant of plants; trackBy: getIdentifier" [value]="plant.id">
    {{ plant.name }}
  </mat-option>
</mat-select>
<ng-container *ngIf="params.context.componentParent.showRowInViewMode(params.node)">
  <ng-container *ngIf="!useCellColorFill">
    <mat-icon class="fa fa-circle m-1 pl-1" [ngStyle]="{ color: iconColor }"> </mat-icon>
    <span>{{ params.value }}</span>
  </ng-container>
  <span *ngIf="useCellColorFill">{{ params.value }}</span>
</ng-container>

